import * as Sentry from '@sentry/react';

export const isDocumentDebugEnabled = (): boolean =>
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_DOCUMENT_DEBUG === 'true';

export const documentDebugLog = (...args: unknown[]): void => {
  if (isDocumentDebugEnabled()) {
    console.log(...args);
  }
};

export const documentDebugWarn = (...args: unknown[]): void => {
  if (isDocumentDebugEnabled()) {
    console.warn(...args);
  }
};

const findErrorArg = (args: unknown[]): Error | undefined => {
  const direct = args.find((arg): arg is Error => arg instanceof Error);
  if (direct) {
    return direct;
  }

  // Errors are often passed inside a context object, e.g. { action, error }.
  return args
    .filter(
      (arg): arg is Record<string, unknown> =>
        typeof arg === 'object' && arg !== null,
    )
    .flatMap((arg) => Object.values(arg))
    .find((value): value is Error => value instanceof Error);
};

// Unlike log/warn, errors are real failures — not debug chatter. Log them in
// every environment and report to Sentry (no-op in dev, where the DSN is
// empty) so production failures stay visible.
export const documentDebugError = (...args: unknown[]): void => {
  console.error(...args);

  const message =
    args.filter((arg) => typeof arg === 'string').join(' ') ||
    '[Documents] error';
  const error = findErrorArg(args);

  if (error) {
    Sentry.captureException(error, { extra: { message } });
  } else {
    Sentry.captureMessage(message, {
      level: 'error',
      extra: { details: args.filter((arg) => typeof arg !== 'string') },
    });
  }
};
